import { type PillProps } from "@validereinc/common-components";
import {
  type FormSchemaType,
  type FormSubmissionType,
} from "@validereinc/domain";

export const FormSubmissionStatusToPillVariantMapping: Record<
  FormSubmissionType["status"],
  PillProps["variant"]
> = {
  validated: "success",
  invalidated: "error",
  pending: "warning",
  submitted: "info",
  draft: "default",
};

export const FormSchemaStatusToPillVariantMapping: Record<
  FormSchemaType["status"],
  PillProps["variant"]
> = {
  active: "success",
  draft: "info",
  archived: "default",
};
